import slice from './slice.uiState';
import * as uiStateTypes from './types.uiState';
import { formatNotification } from './notificationFn.uiState';

export const { reducer: uiState, actions: uiStateActions } = slice;
export { uiStateTypes, formatNotification };
export { default as uiStateSaga } from './saga.uiState';
export { default as uiStateSelector } from './selector.uiState';
export default slice;
